import { Vue, Component } from 'vue-property-decorator';
import query from './query-constructor';
import _, { sortBy, get as _get, uniq } from 'lodash';
import { Route } from 'vue-router';
import { DrillFilterOptionsEnum, DelimitersEnum } from '@/services/models/Enums';

const ORDER = [
  'campaigns', 
  'offers', 
  'flows', 
  'landings', 
  'traffic-sources', 
  'affiliate-networks', 
  'countries', 
  'cities', 
  'states', 
  'languages', 
  'ips', 
  'useragents', 
  'subnet-small', 
  'subnet-big', 
  'isps', 
  'mobile-carriers', 
  'connection-types',
  'browsers',
  'browser-versions',
  'oses',
  'os-versions', 
  'device-models', 
  'device-vendors', 
  'device-types', 
  'screen-resolutions', 
  'referrers', 
  'referrer-domains', 
  'day-of-week', 
  'hour-of-day', 
  'custom1', 
  'custom2', 
  'custom3', 
  'custom4', 
  'custom5', 
  'custom6', 
  'custom7', 
  'custom8', 
  'custom9', 
  'custom10', 
  'day', 
  'month', 
  'conversions', 
  'errors', 
  'live-visits', 
  'live-clicks', 
  'sixth-sense'
];

export interface RefreshReportOptions {
  additionalDataParams?: any;
  additionalReportParams?: any;
  manual?: boolean;
  manualDrilldown?: boolean;
}

export interface LinkOptions {
  isReport?: boolean;
  tabId?: number;
  columnsFromCache?: boolean;
  replaceColumnsWithCurrent?: boolean;
}

export enum ExcludeTypeEnum {
  concat = 'concat',
  slice = 'slice'
}

export interface NextReportProps {
  tableNextReport?: any;
  tableNextReportName?: string;
  tableNextReportGroup?: any;
  tableSelectedItems?: any[];
  tableNextReportExclude?: boolean;
  tableNextReportExcludeType?: ExcludeTypeEnum;
  tableNextReportOnlyDrill?: boolean;
}

@Component
export default class UrlMixin extends Vue {

  getDefautLinkOptions(): LinkOptions {
    return {
      isReport: true,
      tabId: this.$store.getters.activeReportIndex
    }
  }

  get order() {
    const { dimensions } = this.$store.state.reportColumns

    return sortBy(Object.keys(dimensions), function (item: string) {
      return ORDER.indexOf(item) === -1 && 1000 || ORDER.indexOf(item);
    });
  }

  /*
    Get next grouping
  */
  nextType(type: string) { }

  get isDashbord() {
    return this.$route.name === 'app.blank' || this.$route.name === 'app.index'
  }

  get isLiveVisits() {
    return [ 'live-visits', 'live-clicks' ].includes(this.computedType);
  }

  get isClientHintsNoticeVisible() {
    return [ 'oses', 'os-versions', 'browsers', 'browser-versions', 'device-models', 'device-vendors', 'device-types' ].includes(this.computedType);
  }
  
  //#GDB
  get basicType() {
    const { name, params } = this.$route;

    switch(name) {     
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return name.replace('app.', '');

      default:
        return params.type;
    }
  }

  getRouteName(group: string) {
    switch(group) {     
      case 'conversions':
      case 'postbacks':
      case 'errors':
        return 'app.' + group;

      default:
        return 'app.report';
    }
  }
  
  get computedType() {
    return this.$store.state.table.menuOverride || this.basicType || '';
  }

  get mainTabs() {
    return ['campaigns', 'offers', 'landings', 'flows', 'traffic-sources', 'affiliate-networks']
  }

  get isMainTab() {
    return this.mainTabs.includes(this.computedType);
  }

  get isCustomTab() {
    const { type } = this.$route.params

    return !!type?.startsWith('custom')
  }

  get currentReportType() {
    return this.getReportType(this.$route);
  }

  getReportType(currentRoute: Route) {
    switch(currentRoute.name) {
      case 'app.report':
        return currentRoute.params.type;
      
      case 'app.conversions':
        return 'conversions';

      case 'app.postbacks':
        return 'postbacks';
      
      case 'app.errors':
        return 'errors';

      case 'app.live-clicks':
        return 'live-clicks';

      case 'app.live-visits':
        return 'live-visits';

      default: 
        return null;
    }
  }

  get reportDecoded() {
    const report: any = this.$route.params.report || this.$store.state.table.selectedReport;

    return report 
      ? query.decode(report)
      : report;
  }

  get dataDecoded() {
    return this.getDataDecoded();
  }

  getDataDecoded() {
    const data: any = this.$route.params.data;

    return data 
      ? query.decode(data)
      : data;
  }

  get reportDrillCampaign() {
    let result: Bemob.ReportQueryDrill = null;
    if(this.reportDecoded) {
      result = this.reportDecoded.drill
        .filter((e: Bemob.ReportQueryDrill) => !e.filterValues.includes(DelimitersEnum.drillFilterOptions))
        .find((e: Bemob.ReportQueryDrill) => e.filterTables === 'campaigns');

      if(
        !result 
        && this.reportDecoded.filterTables === 'campaigns'
        && !this.reportDecoded.filterValues.includes(DelimitersEnum.drillFilterOptions)
      ) {
        result = {
          filterTables: this.reportDecoded.filterTables,
          filterValues: this.reportDecoded.filterValues
        };
      }
    }

    return result
      ? result.filterValues
      : null;
  }

  /*
    Should set hidden flag for the menu item depending on filters/drilldowns
    RELATED:
      - MainMenu::render()
  */
  isHidden(group: any) {
    if (this.reportDecoded) {
      const hiddenByDrill: string[] = this.reportDecoded.drill
        .filter((item: Bemob.ReportQueryDrill) => item.filterOptions === DrillFilterOptionsEnum.equals)
        .map((item: Bemob.ReportQueryDrill) => item.filterTables);

      let hidden = hiddenByDrill;
      if(this.reportDecoded.filterOptions === DrillFilterOptionsEnum.equals) {
        hidden.push(this.reportDecoded.filterTables);
      }

      return hidden.includes(group);
    }
  }

  isReport() {
    return !!this.$route.params.report;
  }

  isTree() {
    const { view } = this.$store.getters.reportParams;
    return this.isReport() && view === 'tree';
  }

  reportQuery() {
    return (
      (this.$route.params.report &&
        query.decode(this.$route.params.report)) ||
      {}
    );
  }
  
  getReportLink(nextReportProps: NextReportProps = {}) {
    nextReportProps = Object.assign(this.getDefaultNextReportProps(), nextReportProps);
    const { tableNextReport, tableNextReportGroup, tableNextReportExclude, tableSelectedItems } = nextReportProps;
    const { dimensions } = this.$store.state.reportColumns
    let group = tableNextReportExclude 
      ? this.$route.params.type
      : this.order.find((e: any) => this.$route.params.type !== e);
    // let filters = this.$store.getters.tableQueryWithArgs({ groupBy: this.$route.params.type });
    const { columns: storeColumns, order, context } = this.$store.getters.savedColumnsInCurentPreset[this.$route.params.type]

    const filters = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy: context
      }),
      ...order,
      groupBy: context,
      columns: storeColumns,
    }

    let columns = [...storeColumns]

    columns[0] = dimensions[group].mainColumn;

    let next_report_id = tableNextReport.id;

    const filterOptions = tableNextReportExclude
      ? DrillFilterOptionsEnum.not_equals
      : DrillFilterOptionsEnum.equals;

    const filterTables = tableNextReportGroup
      ? tableNextReportGroup
      : this.$route.params.type;

    const filterValues = next_report_id
      ? next_report_id
      : tableSelectedItems
        .map((item) => item.DT_RowId)
        .join(DelimitersEnum.drillFilterOptions);
    
    let report_query = {
      group: group,
      filterTables: filterTables,
      filterValues: filterValues,
      filterOptions: filterOptions,
      drill: <any[]> []
    };

    const report = query.encode(report_query);

    const tableQuery = {
      ...filters,
      offset:0,
      columns,
    };

    const link = `/app/report/${group}/${query.encode(tableQuery)}/${report}`;

    return link;
  }


  get reportLink() {
    return this.getReportLink();
  }

  get reportTabLink() {
    const { type, data,  report } = this.$route.params;

    switch(this.$route.name) {
      case 'app.live-clicks':
        return `/app/live-clicks/${data}/${report}`;
      case 'app.live-visits':
        return `/app/live-visits/${data}/${report}`;
      case 'app.conversions':
        return `/app/conversions/${data}/${report}`;
      case 'app.postbacks':
        return `/app/postbacks/${data}/${report}`;
      case 'app.errors':
        return `/app/errors/${data}/${report}`;
      default: 
        return `/app/report/${type}/${data}/${report}`;
    }
  }

  decodeReportUrl(url: string) {
    const urlRegex = [
      /\/app\/report\/([^\/]+)\/([^\/]+)\/([^\/]+)/,
      /\/app\/live-([^\/]+)\/([^\/]+)\/([^\/]+)/,
      /\/app\/(conversions|errors)\/([^\/]+)\/([^\/]+)/
    ];

    for(let regex of urlRegex) {
      let match = url.match(regex);
      if(match) {
        return {
          type: match[1],
          data: query.decode(match[2]),
          report: query.decode(match[3])
        }
      }
    }

    return null;
  }

  encodeReportUrl(data: any) {
    return `/app/report/${data.type}/${query.encode(data.data)}/${query.encode(data.report)}`;
  }

  normalizeUrl(url: string) {
    let decoded = this.decodeReportUrl(url);
    if(!decoded) {
      return null;
    }

    delete decoded.data.date;
    delete decoded.data.groupBy;
    delete decoded.data.drillPosition;
    delete decoded.data.formatResponse;

    if(decoded.report.levels) {
      decoded.report.levels = decoded.report.levels.filter((item: any) => item);
    } else {
      decoded.report.levels = [];
    }

    return this.encodeReportUrl(decoded);
  } 

  /*
    Navigate
  */
  navigate(group: string, resetOffset: boolean = false) {
    if (group === 'undefined')  {
      return;
    }

    let data = this.$route.params.data;
    
    if(resetOffset) {
      const dataDecoded = query.decode(data);
      dataDecoded.offset = 0;

      data = query.encode(dataDecoded);
    }

    this.$router.push(
      `/app/report/${group}/${data}/${this.$route.params
        .report || ''}`
    );
  }

  /*
    Refresh current path with optional filters
  */
  refreshReport(options: RefreshReportOptions) {
    const additionalDataParams = options.additionalDataParams || {};
    const additionalReportParams = options.additionalReportParams || {};
    const manual: any = options.manual || false;
    const manualDrilldown: any = options.manualDrilldown || false;
    const { type } = this.$route.params;

    const data = query.encode({
      ...this.dataDecoded,
      ...additionalDataParams
    });

    const report = query.encode({
      ...this.reportDecoded,
      ...additionalReportParams
    });

    if (typeof type === 'undefined') {
      return;
    } 

    this.$router.replace({
      name: 'app.report',
      params: {
        type: type,
        data: data,
        report: report,
        manual: manual,
        manualDrilldown: manualDrilldown
      }
    });
  }

  /*
    Get a link for the table
    RELATED:
      - MainMenu
      - Report::getFilters
        + Report::getReport()
  */
  getDashboardLink(resetReport: boolean = false) {
    const filters = this.$store.state.dashboard.query;

    return `/app/dashboard/${query.encode({
      ...filters
    })}?resetSelectedReport=${resetReport}`;
  }

  getHomeLink() {
    const route = this.$store.state.table.lastActiveTab || 'campaigns'
    return this.getLink(route, {
      isReport: false,
      columnsFromCache: true,
      tabId:0
    });
  }

  defaultHomepage() {
    let defaultHomepage = _get(this.$store.state, 'user.defaultHomepage', 'dashboard');
    let route: any;

    switch(defaultHomepage) {
      case 'campaigns':
        route = this.getHomeLink();
        break;

      case 'dashboard':
      default:
        route = this.getDashboardLink(true)

    } 

    return route;
  }

  getLink(group: string, options: LinkOptions = this.getDefautLinkOptions()): Route {
    const { isReport,tabId } = options;

    const savedColumns = this.$store.getters.savedColumnsInCurentPreset

    let columnsSource: any[] = (savedColumns[group]?.columns || []).map(value => ({ value }));

    columnsSource = columnsSource || [];

    const columns = columnsSource.map((item) => item.value);

    const linkData = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy:group,
        tabId:tabId
      }),
      columns,
    }

    const linkDataEncoded = query.encode(linkData);

    const drill = isReport 
      ? this.$route.params.report || this.$store.state.table.selectedReport
      : null;

    return {
      name: this.getRouteName(group),
      params: {
        type: group,
        data: linkDataEncoded,
        report: drill,
        manual: true
      }
    } as any;
  }

  get conversionsLink(): any {
    const { order, columns, context } = this.$store.getters.savedColumnsInCurentPreset.conversions
    const filters = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy:context,
      }),
      ...order,
      groupBy: context,
      columns,
    }

    return {
      name: 'app.conversions',
      params: {
        data: query.encode(filters),
        report: this.$route.params.report,
        manual: true 
      }
    };
  }

  getLivesLink(context: string): any {
    const { order, columns } = this.$store.getters.savedColumnsInCurentPreset[context]

    const filters = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy:context,
      }),
      ...order,
      groupBy:context,
      columns,
    }

    const linkData = query.encode(filters);

    return `/app/${context}/${linkData}/${this.$route.params
      .report || this.$store.state.table.selectedReport || ''}`;
  }

  get errorsLink(): any {
    const { order, columns, context } = this.$store.getters.savedColumnsInCurentPreset.errors
    const filters = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy:context,
      }),
      ...order,
      columns,
      groupBy: context,
    }

    return {
      name: 'app.errors',
      params: {
        data: query.encode(filters),
        report: this.$route.params.report,
        manual: true
      }
    }
  }

  get postbacksLink(): any {
    const { order, columns, context } = this.$store.getters.savedColumnsInCurentPreset.postbacks
    const filters = {
      ...this.$store.getters.reportParamsByTabIdAndGroupBy({
        groupBy:context,
      }),
      ...order,
      columns,
      groupBy: context,
    }

    return {
      name: 'app.postbacks',
      params: {
        data: query.encode(filters),
        report: this.$route.params.report,
        manual: true
      }
    }
  }

  /*
    Close report tab;
    RELATED:
      - Report::clean()
        + commit(tableActiveReports)
  */
  getReturnLink(currentReportId: any) {
    const group = this.order[0];
    const returnLinkData = query.encode(this.$store.getters.reportParamsByTabIdAndGroupBy({ groupBy:group }));

    return `/app/report/${group}/${returnLinkData}?exitReport=${currentReportId}`;
  }

  /*
    Resolve current drilldown state.
    To be lazy-loaded
  */
  get drilldown(): Bemob.ReportQueryDrill[] {
    return this.decodeDrilldown(this.$route.params.report);
  }

  decodeDrilldown(report: any)  {
    if (report) {
      const report_query = query.decode(report);
      const { 
        filterTables, 
        filterValues, 
        filterOptions,
        filterOffset,
        filterLimit,
        drill 
      } = report_query;

      return [
        { 
          filterTables, 
          filterValues, 
          filterOptions,
          filterOffset,
          filterLimit
        }
      ].concat(drill);
    }
    return [];
  }

  getDefaultNextReportProps(): NextReportProps {
    const {
      tableNextReportName,
      table
    } = this.$store.state;

    const { nextReportGroup, selectedItems } = table

    return {
      tableNextReport: this.$store.getters.selectedItem,
      tableNextReportGroup: nextReportGroup,
      tableNextReportName,
      tableSelectedItems: selectedItems,
      tableNextReportExclude: false,
      tableNextReportExcludeType: ExcludeTypeEnum.concat,
      tableNextReportOnlyDrill: false
    }
  }

  drillLink(index: number = undefined, previousFilter: any = null, nextReportProps: NextReportProps = {}) {
    nextReportProps = Object.assign(this.getDefaultNextReportProps(), nextReportProps);
    const {
      tableNextReport,
      tableNextReportGroup, 
      tableNextReportExclude,
      tableSelectedItems,
      tableNextReportExcludeType
    } = nextReportProps;

    let middleDrilldown = previousFilter && previousFilter[0];
    let tableTreeLevel = this.$store.getters.tableQueryForCurrentTab.treeLevels?.[0];
    let restorePage = {};

    let group: string = tableNextReportExclude
      ? this.$route.params.type
      : middleDrilldown 
        ? middleDrilldown.filterTables
        : this.$route.params.type === tableNextReportGroup && tableTreeLevel
          ? tableTreeLevel
          : tableNextReportGroup && this.$route.params.type !== tableNextReportGroup
            ? this.$route.params.type
            : this.order.find((e: any) => this.$route.params.type !== e && !this.isHidden(e));

    if(group !== this.$route.params.type) {
      this.bus.emit('preserve-levels');
    }

    const { dimensions } = this.$store.state.reportColumns
    const savedColumns = this.$store.getters.savedColumnsInCurentPreset


    let columns = _.cloneDeep(savedColumns[this.$route.params.type].columns);

    columns[0] = dimensions[group].mainColumn;

    let filters = this.$store.getters.reportParams;
    let next_report_id = tableNextReport.id;

    let report_query: Bemob.ReportQuery = {
      drill: []
    };

    let current_report_query = this.$route.params.report;
    if (current_report_query) {
      const current_report: any = query.decode(current_report_query);

      report_query.filterTables = current_report.filterTables;
      report_query.filterValues = current_report.filterValues;
      report_query.filterOptions = current_report.filterOptions;
      
      if(typeof current_report.filterOffset !== 'undefined') {
        report_query.filterOffset = current_report.filterOffset
      }

      if(typeof current_report.filterLimit !== 'undefined') {
        report_query.filterLimit = current_report.filterLimit
      }

      report_query.group = current_report.group;
      
      // удаление drilldown
      if (index !== undefined && Number.isInteger(index)) {
        let _drill: Bemob.ReportQueryDrill[] = current_report.drill || [];
        let is_last = _drill.length === index;
        let deleted: Bemob.ReportQueryDrill[];

        if (_drill.length) {
         deleted = _drill.splice(index - 1, 1);
        }

        group = deleted && deleted[0]
          ? deleted[0].filterTables
          : this.$route.params.type;

        report_query.drill = _drill;

        if(!report_query.drill.length) {
          restorePage = {
            offset: report_query.filterOffset,
            limit: report_query.filterLimit
          };
        } else {
          const lastDrillIndex = report_query.drill.length - 1;

          restorePage = {
            offset: report_query.drill[lastDrillIndex].filterOffset,
            limit: report_query.drill[lastDrillIndex].filterLimit
          };
        }

        //let drill_map = current_report.drill.map((x: any) => x.filterTables);

        // IF NEED TO DRILL BACK
        // if (is_last)
        //   group = deleted[0].filterTables;
        // else

        // добавление drilldown
      } else {
        //tableTreeLevels
        let spliceLevel = tableTreeLevel === group 
          ? tableTreeLevel
          : tableNextReportGroup;

        this.bus.emit('splice-level', spliceLevel);
        report_query.drill = current_report.drill;//.concat(this.$store.state.tableTree.filter((e: any) => !!e));
        
        const filterOptions = tableNextReportExclude 
          ? DrillFilterOptionsEnum.not_equals
          : DrillFilterOptionsEnum.equals;
        const filterTables = tableNextReportGroup
          ? tableNextReportGroup
          : this.$route.params.type;

        const exists = report_query.drill.find((e: any) => e.filterTables === filterTables);
        const firstDrill = report_query.filterTables === filterTables;

        const getExcludedFilterValues = (itemFilterValues: string) => {
          const newFilterValuesSplited = itemFilterValues.split(DelimitersEnum.drillFilterOptions);
          const newTableSelectedItems = tableSelectedItems.map((item) => item.DT_RowId);
          const newFilterValues = tableNextReportExcludeType === ExcludeTypeEnum.concat
            ? uniq(newFilterValuesSplited.concat(newTableSelectedItems))
            : newFilterValuesSplited.filter((filterValue) => !newTableSelectedItems.includes(filterValue));
          
          return newFilterValues.join(DelimitersEnum.drillFilterOptions);
        }
        
        if(firstDrill) {
          report_query.filterValues =  getExcludedFilterValues(report_query.filterValues as string);
          report_query.filterOptions = filterOptions;

          // if(tableNextReportExclude) {
          //   report_query.filterValues =  getExcludedFilterValues(report_query.filterValues as string);
          //   report_query.filterOptions = filterOptions;
          // } else {
          //   report_query.filterOptions = filterOptions;
          //   report_query.filterValues = next_report_id;
          // }
        } else if (exists) {
          report_query.drill = report_query.drill.map((item) => {
            if (item.filterTables === filterTables) {
              let filterValues = next_report_id
                ? next_report_id
                : getExcludedFilterValues(item.filterValues);
              
              return {
                filterTables: filterTables,
                filterValues: filterValues,
                filterOptions: filterOptions
              };
            }
               
            return item;
          })
        } else {
          const filterValues = next_report_id
            ? next_report_id
            : tableSelectedItems
              .map((item) => item.DT_RowId)
              .join(DelimitersEnum.drillFilterOptions);

          let newDrill: Bemob.ReportQueryDrill = {
            filterTables: filterTables,
            filterValues: filterValues,
            filterOptions: filterOptions
          };

          const dataDecoded = query.decode(this.$route.params.data);

          if(!report_query.drill.length) {
            report_query.filterOffset = dataDecoded.offset;
            report_query.filterLimit = dataDecoded.limit;
          } else {
            const lastDrillIndex = report_query.drill.length - 1;
           
            report_query.drill[lastDrillIndex].filterOffset = dataDecoded.offset;
            report_query.drill[lastDrillIndex].filterLimit = dataDecoded.limit;
          }

          report_query.drill = report_query.drill.concat([ newDrill ]);
        }
      }
    }

    filters.offset = 0;


    const report = query.encode(report_query);
    const data = query.encode({
      ...filters,
      columns,
      ...restorePage
    });
    // return `/app/report/${group}/${query.encode({
    //   ...filters,
    //   columns
    // })}/${report}`;
    
    return {
      name: 'app.report',
      params: {
        type: group,
        data: data,
        report: report,
        manualDrilldown: true
      }
    }
  }

  drilldownForward(previousFilter: any = null, nextReportProps: NextReportProps = {}) {
    const link = this.getDrilldownForwardLink(previousFilter, nextReportProps);
    this.$router.push(link as any);
  }

  drilldownForwardNewTab(previousFilter: any = null, nextReportProps: NextReportProps = {}) {
    const link = this.getDrilldownForwardLink(previousFilter, nextReportProps);
    this.bus.emit('tab-add', link);
  }

  getDrilldownForwardLink(previousFilter: any, nextReportProps: NextReportProps) {
    const { commit } = this.$store;
    const report = this.reportQuery();

    commit('tableQuery', {
      grouping: this.$route.params.type,
      name: 'drillPosition',
      value: report.drill.length + 1,
      notSetToLocalStorage: this.isReport()
    });

    return this.drillLink(undefined, previousFilter, nextReportProps);
  }

  drilldownBack(index: any) {
    const {commit} = this.$store;
    const report = this.reportQuery();

    commit('tableQuery', {
      grouping: this.$route.params.type as any,
      name: 'drillPosition',
      value: report.drill.length - 1,
      notSetToLocalStorage: this.isReport()
    });

    this.$router.push(this.drillLink(index) as any);
  }

  getGroupByMetric(metric: string) {
    const { dimensions } = this.$store.state.reportColumns

    const column_list = Object.keys(dimensions);
    const columns: {[type: string]: string[]} = {};

    for(let column of column_list) {
      if(metric === dimensions[column].mainColumn) {
        return column;
      }

      columns[column] = dimensions[column].additionalColumns;
    }

    for (let column = column_list.pop(); !!column; column = column_list.pop()) {
      for (let i = 0; i < columns[column].length; i++) {
        if (columns[column][i] === metric)
          return column;
      }
    }
  }

  get isBasicReport() {
    return !this.notReports.includes(this.computedType);
  }

  get notReports() {
    return [ 'conversions', 'postbacks', 'errors', 'live-visits', 'live-clicks' ];
  }
}
